import { connect } from 'react-redux'
import AzureInputs from './AzureInputs.component'
import * as Actions from 'state/actions'

const mapStateToProps = state => {
  return {
    connectionString: state.analyticsExport.exportApiConfig.azureBlob.connectionString,
    containerName: state.analyticsExport.exportApiConfig.azureBlob.containerName,
    isFetching: state.analyticsExport.exportApiConfig.isFetchingExportApiConfig,
    isSaving: state.analyticsExport.exportApiConfig.isFetchingExportApiConfig
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateExportApiConfig: key => e => dispatch(Actions.updateExportApiAzureConfig(key, e.target.value))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AzureInputs)
